import { takeLatest, put } from 'redux-saga/effects'
import {
  // getDemographicDetailsTenant,
  getDemographicDetailsSuperAdmin,
  getSuperAdminPlayerManagement,
  // getTenantPlayerManagement,
  // getTenantLivePlayerReport,
  getSuperAdminLivePlayerReport,
  // getTAPlayerLiability,
  getSAPlayerLiability,
  getSAKPIReport,
  getSAKPISummary,
  // getTAKPIReport,
  // getTAKPISummary,
  getSAGameReport,
  // getTAGameReport,
  // getTAPlayerGameReport,
  getSAPlayerGameReport,
  getElasticHealth,
  getPlayerGameReport,
  getUserStats
} from '../../utils/apiCalls'

import {
  getDemographicReportFailed,
  getDemographicReportComplete,
  getDemographicReportStart,
  getPlayerManagementStart,
  getPlayerManagementComplete,
  getPlayerManagementFailure,
  getLivePlayersReportStart,
  getLivePlayersReportComplete,
  getLivePlayersReportFailure,
  getPlayerLiabilityStart,
  getPlayerLiabilitySuccess,
  getPlayerLiabilityFailure,
  getKPISummaryStart,
  getKPISummarySuccess,
  getKPISummaryFailure,
  getKPIReportStart,
  getKPIReportSuccess,
  getKPIReportFailure,
  getGameReportFailure,
  getGameReportSuccess,
  getGameReportStart,
  getPlayerGameReportFailure,
  getPlayerGameReportSuccess,
  getPlayerGameReportStart,
  getElasticHealthComplete,
  getElasticHealthFailure,
  getPlayerReportFailure,
  getPlayerReportSuccess,
  getPlayerReportStart,
  getUserStatsSuccess,
  getUserStatsFailure,
  getUserStatsStart,
} from '../redux-slices/dashboard'
import { toast } from '../../components/Toast'

export default function* dataWatcher() {
  yield takeLatest(getDemographicReportStart.type, getDemographicDataWorker)
  yield takeLatest(getPlayerManagementStart.type, getPlayerManagementWorker)
  yield takeLatest(getLivePlayersReportStart.type, getTopPlayerReportWorker)
  yield takeLatest(getPlayerLiabilityStart.type, getPlayerLiabilityWorker)
  yield takeLatest(getKPISummaryStart.type, getKPISummaryWorker)
  yield takeLatest(getKPIReportStart.type, getKPIReportWorker)
  yield takeLatest(getGameReportStart.type, getGameReportWorker)
  yield takeLatest(getPlayerReportStart.type, getPlayerReportWorker)
  yield takeLatest(getPlayerGameReportStart.type, getPlayerGameReportWorker)
  yield takeLatest(getUserStatsStart.type, getUserStatsWorker)
  // yield takeLatest(getElasticHealthStart.type, getElasticHealthWorker)
}

function* getDemographicDataWorker(action) {
  try {
    const { isTenant, endDate, startDate, dateOptions } = action && action.payload

    const { data } = yield getDemographicDetailsSuperAdmin({ endDate, startDate, dateOptions });

    yield put(getDemographicReportComplete(data?.data?.demographic))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getDemographicReportFailed(e?.response?.data?.errors[0]?.description))
  }
}

function* getPlayerManagementWorker(action) {
  try {
    const { endDate, startDate, limit, dateOptions, adminId } = action && action.payload

    const { data } = yield getSuperAdminPlayerManagement({ endDate, startDate, adminId, limit, dateOptions })

    yield put(getPlayerManagementComplete(data?.data))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getPlayerManagementFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getTopPlayerReportWorker(action) {
  try {
    // const { adminId, tenantId } = action && action.payload

    // const { data } = getSuperAdminLivePlayerReport({ adminId, tenantId })
    const { data } = yield getSuperAdminLivePlayerReport()
    yield put(getLivePlayersReportComplete(data?.data))
  } catch (e) {
    // yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getLivePlayersReportFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getPlayerLiabilityWorker(action) {
  try {
    const { endDate, startDate, adminId, tenantId, dateOptions } = action && action.payload

    const { data } = yield getSAPlayerLiability({ endDate, startDate, adminId, tenantId, dateOptions })
    console.log('working')
    console.log('@@@@@@@', data);
    yield put(getPlayerLiabilitySuccess(data?.data?.playerLiability))
  } catch (e) {
    console.log('errrrrrrrrrr', e);
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getPlayerLiabilityFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getKPISummaryWorker(action) {
  try {
    const { endDate, startDate, adminId, tenantId, type, dateOptions, search, page, limit } = action && action.payload

    const { data } = yield getSAKPISummary({ endDate, startDate, adminId, tenantId, dateOptions, search, page, limit })
    console.log({ data, type }, "dataaaaaaaaaaaaaaa")
    if (type === 'banking') {
      yield put(getKPISummarySuccess(data?.data?.bonusReport))
    } else if (type === 'casino') {
      yield put(getKPISummarySuccess(data?.data?.result))
    } else {
      yield put(getKPISummarySuccess(data?.data?.bonusReport))
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getKPISummaryFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getUserStatsWorker(action) {
  try {
    const { endDate, startDate, filter, page, limit, search } = action && action.payload

    const { data } = yield getUserStats({ endDate, startDate, filter, page, limit, search })

    yield put(getUserStatsSuccess(data?.data?.result))

  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getUserStatsFailure(e?.response?.data?.errors[0]?.description))
  }
}


function* getKPIReportWorker(action) {
  try {
    const { isTenant, endDate, startDate, adminId, tenantId, dateOptions, selectedTab, search, page, limit } = action && action.payload

    const { data } = yield getSAKPIReport({ endDate, startDate, adminId, tenantId, dateOptions, selectedTab, search, page, limit })
    yield put(getKPIReportSuccess(data?.data?.hostPlayerReport))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getKPIReportFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getGameReportWorker(action) {
  try {
    const { isTenant, endDate, startDate, adminId, tenantId, dateOptions, selectedTab, search, page, limit } = action && action.payload

    const { data } = yield getSAGameReport({ endDate, startDate, adminId, tenantId, dateOptions, selectedTab, search, page, limit })
    yield put(getGameReportSuccess(data?.data?.gameReport))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getGameReportFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getPlayerReportWorker(action) {
  try {
    const { isTenant, endDate, startDate, adminId, tenantId, dateOptions, selectedTab, search, page, limit, hostSearch } = action && action.payload

    const { data } = yield getPlayerGameReport({ endDate, startDate, adminId, tenantId, dateOptions, selectedTab, search, page, limit, hostSearch })
    console.log(data, "dataaaaaaaaaaaaaaaaaaaaaaaaaaaaa", data?.result);
    yield put(getPlayerReportSuccess(data?.data?.result))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getPlayerGameReportFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getPlayerGameReportWorker(action) {
  try {
    const { isTenant, endDate, startDate, dateOptions, selectedTab, limit, userId } = action && action.payload

    const { data } = yield getSAPlayerGameReport({ endDate, startDate, dateOptions, selectedTab, limit, userId })

    yield put(getPlayerGameReportSuccess(data?.data?.gameReport))
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getPlayerGameReportFailure(e?.response?.data?.errors[0]?.description))
  }
}

function* getElasticHealthWorker(action) {
  try {
    const { isTenant } = action && action.payload

    const { data } = yield getElasticHealth(isTenant)

    if (data?.data?.success) {
      yield put(getElasticHealthComplete(data?.data?.success))
    } else {
      yield toast(data?.data?.message, 'error')

      yield put(getElasticHealthFailure())
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(getElasticHealthFailure(e?.response?.data?.errors[0]?.description))
  }
}
